export default "/assets/images/cozy-air-sm.94730fd4c325f49a.jpg";